import { render, staticRenderFns } from "./CampusList.vue?vue&type=template&id=67c022dc&scoped=true&"
import script from "./CampusList.vue?vue&type=script&lang=ts&"
export * from "./CampusList.vue?vue&type=script&lang=ts&"
import style0 from "./CampusList.vue?vue&type=style&index=0&id=67c022dc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c022dc",
  null
  
)

export default component.exports